const ArrowUp = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 5l7 7h-4v7h-6v-7H5z" />
  </svg>
);

const ArrowDown = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 19l-7-7h4V5h6v7h4z" />
  </svg>
);

/**
 * @param delta  Fractional change vs the previous period (0.12 = +12%), or
 *               null when comparison is off or the previous period was empty.
 * @param invert Set for metrics where lower is better.
 */
export function MetricCard({ title, value, color, delta, previousLabel, invert = false }) {
  const hasDelta = typeof delta === 'number' && Number.isFinite(delta);
  const isUp = hasDelta && delta > 0;
  const isFlat = hasDelta && Math.abs(delta) < 0.0005;
  const isGood = invert ? !isUp : isUp;

  return (
    <div
      data-metric={title}
      className="flex flex-col items-center justify-center rounded-lg border border-card-line border-t-card-line-top bg-card p-5 shadow-soft max-md:px-2.5 max-md:py-3.5"
    >
      <div className="mb-2 text-sm font-medium tracking-[0.05em] text-fg-muted uppercase max-md:mb-1.5 max-md:text-center max-md:text-[0.7rem]">
        {title}
      </div>
      <div
        className="max-w-full text-center text-2xl font-bold tracking-[-0.02em] break-words max-md:text-[1.15rem]"
        style={{ color: color || 'var(--color-fg)' }}
      >
        {value}
      </div>

      {hasDelta && (
        <div
          className={`mt-1.5 flex items-center gap-1 text-[0.75rem] font-medium ${
            isFlat ? 'text-fg-subtle' : isGood ? 'text-success' : 'text-danger'
          }`}
          title={previousLabel ? `Previous period: ${previousLabel}` : undefined}
        >
          {!isFlat && (isUp ? <ArrowUp /> : <ArrowDown />)}
          {isFlat ? '±0%' : `${isUp ? '+' : ''}${(delta * 100).toFixed(1)}%`}
          <span className="text-fg-subtle">vs prev</span>
        </div>
      )}
    </div>
  );
}
